import { useTranslation } from "react-i18next";
import { CATEGORY_MAP, STATUS_STYLES, relativeDate } from "../lib/constants";

export default function ItemCard({ item, onClick }) {
  const { t } = useTranslation();
  const cat = CATEGORY_MAP[item.category] || CATEGORY_MAP.other;
  const Icon = cat.icon;
  const overdue = item.status === "due" && item.due_date && new Date(item.due_date + "T00:00:00") < new Date(new Date().setHours(0, 0, 0, 0));
  const statusKey = overdue ? "overdue" : item.status;
  const cls = STATUS_STYLES[statusKey] || STATUS_STYLES.upcoming;

  return (
    <button data-testid={`item-card-${item.id}`} onClick={() => onClick(item)}
      className="w-full text-left bg-card border border-border rounded-xl p-4 hover:shadow-md hover:border-brand/40 transition-all group">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-lg flex items-center justify-center shrink-0"
          style={{ backgroundColor: cat.bg }}>
          <Icon className="h-5 w-5" style={{ color: cat.color }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <p className="font-medium text-sm leading-snug truncate group-hover:text-brand transition-colors">{item.title}</p>
            {item.priority === "high" && (
              <span className="text-[10px] font-mono uppercase text-red-500 shrink-0">{t("status.high")}</span>
            )}
          </div>
          {item.action && <p className="text-xs text-muted-foreground truncate mt-0.5">{item.action}</p>}
          <div className="flex items-center gap-2 mt-2">
            <span data-testid="item-status-chip" className={`text-[11px] px-2 py-0.5 rounded-full border font-medium ${cls}`}>
              {t(`status.${statusKey}`)}
            </span>
            <span className="text-xs text-muted-foreground">{relativeDate(item.due_date)}</span>
            {item.amount != null && (
              <span className="text-xs font-medium ml-auto font-mono">
                {item.currency || ""} {item.amount}
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}
